<div class="preview-settings">
  <mode-notebook-toolbar
    *ngIf="notebook._resource?.token"
    [notebookToken]="notebook._resource.token"
    [session]="session$ | async"
  ></mode-notebook-toolbar>

  <a class="sidebar-toggle" (click)="toggleSidebar()">
    <capra-icon icon="icon-collapse-panel" [ngClass]="(sidebarOpen$ | async) ? 'collapse' : 'expand'"></capra-icon>
  </a>
</div>

<mode-status-bar
  *ngIf="latestNotebookState$ | async"
  [state]="latestNotebookState$ | async"
  [ngClass]="{
    'sidebar-offset': sidebarOpen$ | async,
    refresh: notebookStateIsAlert$ | async,
  }"
>
  <div slot="cancelled">Notebook run has been cancelled</div>
  <div slot="warning">Notebook is having trouble, try running again</div>
  <div slot="error">
    {{ notebookStateMessage$ | async }}
    <button (click)="restartSession()">Restart</button>
  </div>
  <div slot="alert" class="alert-container">
    New {{ isRegisterImportedDatasetEnabled ? 'data' : 'query data' }} is available
    <button (click)="loadReportRun()" class="refresh-button">Refresh and run all</button>
  </div>
  <div slot="running">Running {{ notebookStateMessage$ | async }}</div>
  <div slot="loading">{{ notebookStateMessage$ | async }}</div>
  <div slot="ready">Ready</div>
</mode-status-bar>

<mode-notebook-container
  class="mode-notebook-container"
  [ngClass]="{ 'with-secondary': sidebarOpen$ | async }"
  *ngIf="notebook._resource?.token"
  notebookHotkeys
>
  <div
    class="mode-notebook-cell-wrapper clearfix"
    [ngClass]="{ 'mode-notebook-hide': !notebookSessionService.initialized }"
  >
    <mode-upgrade-banner
      *ngIf="isPythonPerformanceFirstTier"
      [pythonPerformanceFirstTier]="isPythonPerformanceFirstTier"
      class="mode-upgrade-banner"
    ></mode-upgrade-banner>

    <ng-container *ngFor="let cellToken of cellTokens$ | async">
      <mode-notebook-cells-group
        [cellToken]="cellToken"
        [notebookToken]="notebook._resource.token"
        [session]="session$ | async"
      ></mode-notebook-cells-group>
    </ng-container>
  </div>
</mode-notebook-container>
